import React from 'react';
import { BiSearch } from "react-icons/bi";
import "./Datatable.css";
import TextField from '../textField/TextField';


const SearchBar = ({ searchTerm, setSearchTerm }) => {
    return (
        <div className="table-heading">
            {/* <div className="searchable-data">
                <div className='position-relative w-100'>
                    <input type='text' name='searchAgentGroup' className='searchTableRecord position-absolute' placeholder='Search' value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                    <div className='d-flex justify-content-center align-items-center position-absolute' style={{ width: 37, height: 37 }}>
                        <BiSearch />
                    </div>
                </div>
            </div> */}

            <TextField
                type='text'
                name='searchAgentGroup'
                placeholder='Search'
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                IconProp={BiSearch}
            />
        </div>
    )
}

export default SearchBar
